/* eslint-disable */
import R from 'ramda';
import actionTypes from '../actionTypes';

const initialState = {
  teams: [],
  selectedTeam: null,
};

export default (state = initialState, action) => {
  let index;

  switch (action.type) {
    case actionTypes.TEAMS_GET_ERROR:
      return { ...state, status: action.type, teams: [] };

    case actionTypes.TEAMS_GET_SUCCESS:
      return { ...state, status: action.type, teams: action.teams };

    case actionTypes.TEAM_GET_ERROR:
      return { ...state, status: action.type, selectedTeam: null };

    case actionTypes.TEAM_CREATE_REQUEST:
    case actionTypes.TEAM_DELETE_REQUEST:
    case actionTypes.TEAM_UPDATE_REQUEST:
    case actionTypes.TEAM_DELETE_ERROR:
    case actionTypes.TEAM_ARCHIVE_ERROR:
    case actionTypes.TEAM_RECOVER_ERROR:
      return { ...state, status: action.type };

    case actionTypes.TEAM_GET_SUCCESS:
    case actionTypes.TEAM_SELECT:
      return { ...state, status: action.type, selectedTeam: action.team };

    case actionTypes.TEAM_CREATE_SUCCESS:
      return {
        ...state,
        status: action.type,
        selectedTeam: action.team,
        teams: state.teams.concat(action.team),
      };

    case actionTypes.TEAM_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.team.id))(state.teams);
      if (index === -1) {
        return {
          ...state,
          status: action.type,
          selectedTeam: action.team,
          teams: state.teams.concat(action.team),
        };
      } else {
        state.teams[index] = action.team;
        return {
          ...state,
          status: action.type,
          selectedTeam: action.team,
          teams: [...state.teams],
        };
      }

    case actionTypes.TEAM_DELETE_SUCCESS:
      index = R.findIndex(R.propEq('id', parseInt(action.teamId)))(state.teams);
      if (index !== -1) {
        return {
          ...state,
          status: action.type,
          selectedTeam: null,
          teams: R.remove(index, 1, state.teams),
        };
      } else {
        return { ...state, status: action.type, selectedTeam: null };
      }

    case actionTypes.TEAM_ARCHIVE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.team.id))(state.teams);
      if (index === -1) {
        return {
          ...state,
          status: action.type,
          selectedTeam: action.team,
          teams: state.teams.concat(action.team),
        };
      } else {
        state.teams[index] = action.team;
        return {
          ...state,
          status: action.type,
          teams: [...state.teams],
        };
      }

    case actionTypes.TEAM_RECOVER_SUCCESS:
      index = R.findIndex(R.propEq('id', action.team.id))(state.teams);
      if (index === -1) {
        return {
          ...state,
          status: action.type,
          teams: state.teams.concat(action.team),
        };
      } else {
        state.teams[index] = action.team;
        return {
          ...state,
          status: action.type,
          teams: [...state.teams],
        };
      }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/teams.js